export interface Currency {
  code: string;
  symbol: string;
  country: string;
  /** ISO 3166-1 alpha-2 country code for flag image */
  countryCode: string;
}

export const currencies: Currency[] = [
  { code: "USD", symbol: "$", country: "United States", countryCode: "us" },
  { code: "GBP", symbol: "\u00A3", country: "United Kingdom", countryCode: "gb" },
  { code: "EUR", symbol: "\u20AC", country: "Europe", countryCode: "eu" },
  { code: "AUD", symbol: "$", country: "Australia", countryCode: "au" },
  { code: "CAD", symbol: "$", country: "Canada", countryCode: "ca" },
  { code: "ZAR", symbol: "R", country: "South Africa", countryCode: "za" },
  { code: "JPY", symbol: "\u00A5", country: "Japan", countryCode: "jp" },
  { code: "CNY", symbol: "\u00A5", country: "China", countryCode: "cn" },
  { code: "INR", symbol: "\u20B9", country: "India", countryCode: "in" },
  { code: "CHF", symbol: "CHF", country: "Switzerland", countryCode: "ch" },
  { code: "SEK", symbol: "kr", country: "Sweden", countryCode: "se" },
  { code: "NOK", symbol: "kr", country: "Norway", countryCode: "no" },
  { code: "DKK", symbol: "kr", country: "Denmark", countryCode: "dk" },
  { code: "NZD", symbol: "$", country: "New Zealand", countryCode: "nz" },
  { code: "SGD", symbol: "$", country: "Singapore", countryCode: "sg" },
  { code: "HKD", symbol: "$", country: "Hong Kong", countryCode: "hk" },
  { code: "KRW", symbol: "\u20A9", country: "South Korea", countryCode: "kr" },
  { code: "MXN", symbol: "$", country: "Mexico", countryCode: "mx" },
  { code: "BRL", symbol: "R$", country: "Brazil", countryCode: "br" },
  { code: "ARS", symbol: "$", country: "Argentina", countryCode: "ar" },
  { code: "CLP", symbol: "$", country: "Chile", countryCode: "cl" },
  { code: "COP", symbol: "$", country: "Colombia", countryCode: "co" },
  { code: "PEN", symbol: "S/", country: "Peru", countryCode: "pe" },
  { code: "THB", symbol: "\u0E3F", country: "Thailand", countryCode: "th" },
  { code: "MYR", symbol: "RM", country: "Malaysia", countryCode: "my" },
  { code: "IDR", symbol: "Rp", country: "Indonesia", countryCode: "id" },
  { code: "PHP", symbol: "\u20B1", country: "Philippines", countryCode: "ph" },
  { code: "VND", symbol: "\u20AB", country: "Vietnam", countryCode: "vn" },
  { code: "TWD", symbol: "NT$", country: "Taiwan", countryCode: "tw" },
  { code: "PKR", symbol: "\u20A8", country: "Pakistan", countryCode: "pk" },
  { code: "BDT", symbol: "\u09F3", country: "Bangladesh", countryCode: "bd" },
  { code: "LKR", symbol: "\u20A8", country: "Sri Lanka", countryCode: "lk" },
  { code: "AED", symbol: "\u062F.\u0625", country: "UAE", countryCode: "ae" },
  { code: "SAR", symbol: "\uFDFC", country: "Saudi Arabia", countryCode: "sa" },
  { code: "QAR", symbol: "\uFDFC", country: "Qatar", countryCode: "qa" },
  { code: "KWD", symbol: "\u062F.\u0643", country: "Kuwait", countryCode: "kw" },
  { code: "BHD", symbol: "BD", country: "Bahrain", countryCode: "bh" },
  { code: "OMR", symbol: "\uFDFC", country: "Oman", countryCode: "om" },
  { code: "JOD", symbol: "JD", country: "Jordan", countryCode: "jo" },
  { code: "EGP", symbol: "E\u00A3", country: "Egypt", countryCode: "eg" },
  { code: "NGN", symbol: "\u20A6", country: "Nigeria", countryCode: "ng" },
  { code: "KES", symbol: "KSh", country: "Kenya", countryCode: "ke" },
  { code: "GHS", symbol: "GH\u20B5", country: "Ghana", countryCode: "gh" },
  { code: "TZS", symbol: "TSh", country: "Tanzania", countryCode: "tz" },
  { code: "UGX", symbol: "USh", country: "Uganda", countryCode: "ug" },
  { code: "MAD", symbol: "MAD", country: "Morocco", countryCode: "ma" },
  { code: "TND", symbol: "DT", country: "Tunisia", countryCode: "tn" },
  { code: "BWP", symbol: "P", country: "Botswana", countryCode: "bw" },
  { code: "MUR", symbol: "\u20A8", country: "Mauritius", countryCode: "mu" },
  { code: "NAD", symbol: "$", country: "Namibia", countryCode: "na" },
  { code: "PLN", symbol: "z\u0142", country: "Poland", countryCode: "pl" },
  { code: "CZK", symbol: "K\u010D", country: "Czech Republic", countryCode: "cz" },
  { code: "HUF", symbol: "Ft", country: "Hungary", countryCode: "hu" },
  { code: "RON", symbol: "lei", country: "Romania", countryCode: "ro" },
  { code: "BGN", symbol: "\u043B\u0432", country: "Bulgaria", countryCode: "bg" },
  { code: "HRK", symbol: "kn", country: "Croatia", countryCode: "hr" },
  { code: "RSD", symbol: "din", country: "Serbia", countryCode: "rs" },
  { code: "TRY", symbol: "\u20BA", country: "Turkey", countryCode: "tr" },
  { code: "ILS", symbol: "\u20AA", country: "Israel", countryCode: "il" },
  { code: "RUB", symbol: "\u20BD", country: "Russia", countryCode: "ru" },
  { code: "UAH", symbol: "\u20B4", country: "Ukraine", countryCode: "ua" },
  { code: "ISK", symbol: "kr", country: "Iceland", countryCode: "is" },
  { code: "JMD", symbol: "$", country: "Jamaica", countryCode: "jm" },
  { code: "TTD", symbol: "$", country: "Trinidad & Tobago", countryCode: "tt" },
  { code: "BBD", symbol: "$", country: "Barbados", countryCode: "bb" },
  { code: "FJD", symbol: "$", country: "Fiji", countryCode: "fj" },
  { code: "PGK", symbol: "K", country: "Papua New Guinea", countryCode: "pg" },
  { code: "XOF", symbol: "CFA", country: "West Africa (CFA)", countryCode: "sn" },
  { code: "XAF", symbol: "FCFA", country: "Central Africa (CFA)", countryCode: "cm" },
];

/** Build a code→symbol lookup map */
export const currencySymbolMap: Record<string, string> = Object.fromEntries(
  currencies.map((c) => [c.code.toLowerCase(), c.symbol])
);

/** Get the symbol for a currency code (case-insensitive), defaults to £ */
export function getCurrencySymbol(code?: string): string {
  return currencySymbolMap[code?.toLowerCase() || "gbp"] || "\u00A3";
}

/** Build a code→countryCode lookup map */
const currencyCountryCodeMap: Record<string, string> = Object.fromEntries(
  currencies.map((c) => [c.code.toLowerCase(), c.countryCode])
);

/** Get the flag image URL for a currency code. Uses flagcdn.com for all currencies. */
export function getCurrencyFlag(code?: string): string {
  const key = code?.toLowerCase() || "gbp";
  const countryCode = currencyCountryCodeMap[key] || "gb";
  return `https://flagcdn.com/w80/${countryCode}.png`;
}
